import { GroupAvatar } from '@modules/conversations/features/all-members-conversation/components/group-avatar';
import { capitalize } from '@shared/utils/capitalize';
import { useChatPreviewTime } from '@modules/members/hooks/use-chat-preview-time';
import { useTranslation } from 'react-i18next';
import { UnreadBadge } from './unread-badge';
import { ChatPreviewLine } from './chat-preview-line';
import { MemberChatPreview } from '@modules/members/members.types';

export type AllMembersCardProps = {
  isOnline: boolean;
  chat?: MemberChatPreview;
  unreadCount?: number | null;
};

export function AllMembersCard(props: AllMembersCardProps) {
  const { isOnline, chat, unreadCount } = props;
  const { t } = useTranslation();
  const displayDateTime = useChatPreviewTime(chat?.at);

  return (
    <div className="flex gap-2.5 items-center h-9.5">
      <GroupAvatar size={36} isOnline={isOnline} />
      <div className="flex-1 min-w-0 flex flex-col justify-center leading-4">
        <div className="flex items-center justify-between gap-2">
          <span className="leading-5 text-[15px] lg:text-base text-text-700 group-[.ant-menu-item-selected]:text-text-800 truncate">
            {capitalize(t('all_members'))}
          </span>
          {displayDateTime ? <span className="text-xs text-text-500 shrink-0">{displayDateTime}</span> : null}
        </div>

        <div className="flex items-center justify-between gap-2">
          <ChatPreviewLine chat={chat} />
          <UnreadBadge count={unreadCount} />
        </div>
      </div>
    </div>
  );
}
